import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from "../../ui/FormElement";

import routes from "../../app/routes";
import axios from "axios";

export default function MemberCreateForm({ closeForm }) {
  let FormSchema = Yup.object().shape({
    email: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
  });

  let [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  });

  const prepareFormDataForSend = (values) => {
    let formData = {
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      password: values.password,
    };
    return formData;
  };

  const formSendSuccess = () => {
    closeForm();
    swal("Member created.");

    const event = new Event("buildTable");
    document.getElementById("student_dataTables").dispatchEvent(event);
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    axios
      .post(routes.api.users.registration, {
        user: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        setLoader(false);

        formSendSuccess();
      })
      .catch(function (error, data) {
        setLoader(false);

        error.response.data.errors.forEach((element) => {
          switch (element.source.pointer) {
            case "/data/attributes/password":
              setErrors({ password: element.detail });
              break;
            case "/data/attributes/email":
              setErrors({ email: element.detail });
              break;
            default:
              setErrors({ email: element.detail });
          }
        });
      });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="firstName"
        label={
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="lastName"
        label={
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="email"
        type="email"
        label={
          <>
            <span>Email</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="password"
        type="password"
        label={
          <>
            <span>Password</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Create"}
          className="btn width-120 btn-primary submit-button mr5 ml5"
        />
      </div>
    </BaseForm>
  );
}
